import styled from '@emotion/styled';
import React from 'react';
import { ColoredChipDark } from '../../../../../components/ColoredChip';
import { useUnsafeTranslation } from '../../../../../i18next';
import { AutomationStats } from '../../../../../services/experiences/automation';
import { ExperienceStatsSimple } from '../../../../../services/experiences/instance';
import { TaskStats } from '../../../../../services/experiences/task';

const StatsContainer = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: p.theme.spacing()
}));

export const AutomationStatsChips = ({ stats }: { stats: AutomationStats }) => {
  const { t } = useUnsafeTranslation();

  return (
    <StatsContainer>
      {!!stats.done && (
        <ColoredChipDark size="small" color="green">
          {t('{{ count }} completed', { count: stats.done })}
        </ColoredChipDark>
      )}
      {!!stats.error && (
        <ColoredChipDark size="small" color="red">
          {t('{{ count }} errored', { count: stats.error })}
        </ColoredChipDark>
      )}
      {!!stats.upcoming && (
        <ColoredChipDark size="small" color="gray">
          {t('{{ count }} upcoming', { count: stats.upcoming })}
        </ColoredChipDark>
      )}
    </StatsContainer>
  );
};

export const TaskStatChips = ({ stats }: { stats: TaskStats }) => {
  const { t } = useUnsafeTranslation();
  return (
    <StatsContainer>
      {!!stats.notStarted && (
        <ColoredChipDark size="small" color="gray">
          {stats.notStarted} {t('upcoming')}
        </ColoredChipDark>
      )}
      {!!stats.inProgressOnTime && (
        <ColoredChipDark size="small" color="blue">
          {stats.inProgressOnTime} {t('on time')}
        </ColoredChipDark>
      )}
      {!!stats.totalDone && (
        <ColoredChipDark size="small" color="green">
          {stats.totalDone} {t('done')}
        </ColoredChipDark>
      )}
      {!!stats.inProgressLate && (
        <ColoredChipDark size="small" color="red">
          {stats.inProgressLate} {t('late')}
        </ColoredChipDark>
      )}
    </StatsContainer>
  );
};

export const ExperienceStatChips = ({
  stats,
  v = 1
}: {
  stats: ExperienceStatsSimple;
  v?: 1 | 2;
}) => {
  const { t } = useUnsafeTranslation();
  if (v === 2) {
    return (
      <StatsContainer>
        {!!stats.onTrack && (
          <ColoredChipDark size="small" color="green">
            {stats.onTrack} {t('on track')}
          </ColoredChipDark>
        )}
        {!!stats.notOnTrack && (
          <ColoredChipDark size="small" color="red">
            {stats.notOnTrack} {t('overdue')}
          </ColoredChipDark>
        )}
      </StatsContainer>
    );
  }
  return (
    <StatsContainer>
      {!!stats.done && (
        <ColoredChipDark size="small" color="green">
          {stats.done} {t('completed all due tasks')}
        </ColoredChipDark>
      )}
      {!!stats.todo && (
        <ColoredChipDark size="small" color="blue">
          {stats.todo} {t('on time with open tasks')}
        </ColoredChipDark>
      )}
      {!!stats.overdue && (
        <ColoredChipDark size="small" color="red">
          {stats.overdue} {t('with overdue tasks')}
        </ColoredChipDark>
      )}
      {!!stats.upcoming && (
        <ColoredChipDark size="small" color="gray">
          {stats.upcoming} {t('not started')}
        </ColoredChipDark>
      )}
    </StatsContainer>
  );
};
